import React, { useEffect, useState } from 'react';
//Material-UI
import Button from '@material-ui/core/Button';
import Modal from '@material-ui/core/Modal';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import StepConnector from '@material-ui/core/StepConnector';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
//Icons
import { X, ClipboardList, Adjustments, Bell, Check } from 'tabler-icons-react';
//Helpers
import clsx from 'clsx';
//Context
import { useLlamadas } from './LlamadasContext';
//Styles
import '../../styles/llamadas.css';

/* ── Custom connector ── */
const ColorConnector = withStyles({
    alternativeLabel: { top: 20 },
    active: {
        '& $line': {
            background: 'linear-gradient(90deg, var(--color, #903bff) 0%, var(--color-secondary, #472A7A) 100%)',
            transition: 'background 0.55s ease',
        },
    },
    completed: {
        '& $line': {
            background: 'linear-gradient(90deg, var(--color, #903bff) 0%, var(--color-secondary, #472A7A) 100%)',
        },
    },
    line: {
        height: 3,
        border: 0,
        backgroundColor: '#e9ecf0',
        borderRadius: 2,
        transition: 'background 0.55s ease',
    },
})(StepConnector);

/* ── Custom step icon ── */
const useStepIconStyles = makeStyles({
    root: {
        backgroundColor: '#dbe0ea',
        color: '#fff',
        width: 42,
        height: 42,
        display: 'flex',
        flexShrink: 0,
        borderRadius: '50%',
        justifyContent: 'center',
        alignItems: 'center',
        lineHeight: 0,
        transition: 'background 0.45s ease, box-shadow 0.45s ease',
    },
    active: {
        background: 'linear-gradient(135deg, var(--color, #903bff) 0%, var(--color-secondary, #472A7A) 100%)',
        boxShadow: '0 4px 14px color-mix(in srgb, var(--color-primary) 40%, transparent)',
    },
    completed: {
        background: 'linear-gradient(135deg, var(--color, #903bff) 0%, var(--color-secondary, #472A7A) 100%)',
    },
});

const STEP_ICONS = {
    1: <ClipboardList size={20} />,
    2: <Adjustments size={20} />,
    3: <Bell size={20} />,
};

function ColorStepIcon({ active, completed, icon }) {
    const classes = useStepIconStyles();
    return (
        <div
            key={active ? `active-${icon}` : icon}
            className={clsx(classes.root, {
                [classes.active]: active,
                [classes.completed]: completed,
                'llamada-step-icon-fill': active,
            })}
        >
            {completed ? <Check size={18} strokeWidth={2.5} /> : STEP_ICONS[String(icon)]}
        </div>
    );
}

const STEPS = ['General', 'Tipo', 'Notificaciones'];

function PopUp(props) {
    const { setStep, nuevo, setNuevo, editar, setEditar, clear, step } = useLlamadas();
    const [open, setOpen] = useState(false);

    useEffect(() => {
        switch (props.name) {
            case 'nuevo':  setOpen(nuevo);  break;
            case 'editar': setOpen(editar); break;
            default: break;
        }
    }, [nuevo, editar, props.name]);

    const handleOpen = () => {
        switch (props.name) {
            case 'nuevo':  setNuevo(true);  break;
            case 'editar': setEditar(true); break;
            default: break;
        }
    };

    const handleClose = () => {
        setStep(0);
        switch (props.name) {
            case 'nuevo':  setNuevo(false);  break;
            case 'editar': setEditar(false); break;
            default: break;
        }
        clear();
    };

    return (
        <div>
            <Button
                variant={props.isContained}
                color={props.colorButton}
                className={props.buttonClass}
                onClick={handleOpen}
                disabled={!props.isActive}
            >
                {props.textButton}
            </Button>
            <Modal open={open} onClose={handleClose}>
                <div className="llamada-modal">
                    <div className="llamada-modal-header">
                        <h2 className="popuptitle">{props.title}</h2>
                        <IconButton size="small" onClick={handleClose}>
                            <X size={20} />
                        </IconButton>
                    </div>
                    <div className="llamada-modal-stepper">
                        <Stepper
                            activeStep={step}
                            alternativeLabel
                            connector={<ColorConnector />}
                        >
                            {STEPS.map((label) => (
                                <Step key={label}>
                                    <StepLabel StepIconComponent={ColorStepIcon}>
                                        {label}
                                    </StepLabel>
                                </Step>
                            ))}
                        </Stepper>
                    </div>
                    <div className="llamada-modal-body">
                        <div key={step} className="llamada-step-animate">
                            {props.popupBody}
                        </div>
                    </div>
                    <div className="llamada-modal-footer">
                        {props.popupFooter}
                    </div>
                </div>
            </Modal>
        </div>
    );
}

PopUp.defaultProps = {
    textButton: 'Agregar',
    colorButton: 'primary',
    title: 'Título',
    isContained: 'contained',
    isActive: true,
    popupFooter: null,
};

export default PopUp;
